import { render, staticRenderFns } from "./LexinKeyboardContent.vue?vue&type=template&id=1c3ee5d6&"
import script from "./LexinKeyboardContent.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports